module.exports = __webpack_public_path__ + "img/white-arrow.03cb343c.svg";